import { useEffect, useState } from "react";
import "./UpdateBanner.css";

// "Nueva versión — Actualizar": a deploy changes the name of the app's main script (main.<hash>.js), so the app
// reads the live index.html (no-store: never a saved copy) and compares that name with the one it is running.
// Checked when the app comes back to the screen and every 10 minutes while it is open — an installed app can stay
// open in the background for days. Not on the development server (its script is bundle.js, there is no deploy).
const CHECK_EVERY = 10 * 60 * 1000;
const MAIN_RE = /\/static\/js\/main\.[0-9a-f]+\.js/;

const runningMain = () => {
  const s = [...document.scripts].find(el => MAIN_RE.test(el.src || ""));
  return s ? s.src.match(MAIN_RE)[0] : null;
};

export default function UpdateBanner() {
  const [latest, setLatest] = useState(null);       // the deployed main script, when it differs from the running one
  const [hidden, setHidden] = useState(null);       // the one the user closed with ✕ (shown again for a newer deploy)

  useEffect(() => {
    const current = runningMain();
    if (process.env.NODE_ENV !== "production" || !current) return undefined;
    let busy = false;
    const check = async () => {
      if (busy || document.visibilityState !== "visible") return;
      busy = true;
      try {
        const res = await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" });
        const found = res.ok ? (await res.text()).match(MAIN_RE) : null;
        if (found && found[0] !== current) setLatest(found[0]);
      } catch { /* offline: try again later */ }
      finally { busy = false; }
    };
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);
    const timer = setInterval(check, CHECK_EVERY);
    check();
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", check);
      clearInterval(timer);
    };
  }, []);

  if (!latest || latest === hidden) return null;
  return (
    <div className="update-banner" role="status">
      <span className="update-banner-dot" aria-hidden="true" />
      <span className="update-banner-text">Hay una nueva versión de la app</span>
      <button type="button" className="update-banner-go" onClick={() => window.location.reload()}>Actualizar</button>
      <button type="button" className="update-banner-x" onClick={() => setHidden(latest)} title="Ahora no" aria-label="Cerrar">✕</button>
    </div>
  );
}
